import { LitElement } from "lit";
import { customElement } from "lit/decorators.js";
import { SlhCoreTooltip } from "@slhuicore/tooltip";
import { style } from "./assets/tooltip.generated-style";

/**
 * A tooltip component that must surround the element whose content it is supposed to display.
 * Tooltip attributes indicate the width and position.
 * Width must be in pixels.
 * Position can be one of: top, bottom, left and right. Position of tooltip depends on the element which surround.
 * The set position can be changed depending on the free space.
 * The text is the broader content of the surrounding element and must be passed to the default slot.
 *
 * @CustomElement slh-tooltip
 *
 * @cssprop --slh-default-font-family - Font family.
 * @cssprop --slh-color-neutral-shade-00 - Font color.
 * @cssprop --slh-color-neutral-shade-80 - Background color.
 * @cssprop --slh-base-xxs-font-size - Font size.
 * @cssprop --slh-base-xxs-line-height - Line height.
 * @cssprop --slh-base-bold-font-weight - Font weight.
 *
 * @slot default - element that is hovered to display the tooltip.
 * @slot content - content of tooltip.
 */
@customElement("slh-tooltip")
export default class SlhTooltip extends SlhCoreTooltip(LitElement) {
  static styles = style;
}
